import { render, staticRenderFns } from "./NegativeBalanceTableMobile.vue?vue&type=template&id=6e5abf25&scoped=true"
import script from "./NegativeBalanceTableMobile.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5abf25",
  null
  
)

export default component.exports